export default __webpack_public_path__ + "static/stacked-area-4abc83a797f621edd35c02a464236bc7.png";